import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class SectorService extends ServiceCRUD {
  constructor() {
    super('/api/ddrs');
  }
}

export default new SectorService();
